import React from 'react';
import styles from './Badge.module.css';

type StatusType = 'PENDING' | 'APPROVED' | 'REJECTED' | 'PENDING_REVIEW' | 'COMPLETED';

interface BadgeProps {
  status: StatusType;
  children: React.ReactNode;
  className?: string;
}

const statusClassMap: Record<StatusType, string> = {
  PENDING: styles.badgePending,
  PENDING_REVIEW: styles.badgePending,
  APPROVED: styles.badgeSuccess,
  COMPLETED: styles.badgeSuccess,
  REJECTED: styles.badgeError,
};

export const Badge: React.FC<BadgeProps> = ({ status, children, className }) => {
  const statusClass = statusClassMap[status] || styles.badge;

  return (
    <span className={`${styles.badge} ${statusClass} ${className || ''}`}>
      {children}
    </span>
  );
};
